const PROJECT_ID = 'cf6a3489-9db0-408d-9584-8086b110e180'
const CDN_HOST = 'https://assets.auxodev.dk'

/**
 * Robust image optimization helper that works both in Vite dev preview and production.
 * Generates Cloudflare cdn-cgi transformed image URLs pointing to the Auxo asset CDN.
 */
export function getOptimizedImageUrl(url, { width = 800, quality = 80, height } = {}) {
  if (!url || typeof url !== 'string') return ''

  // Already transformed
  if (url.includes('/cdn-cgi/image/')) return url

  const params = [`width=${width}`, `quality=${quality}`, 'format=auto']
  if (height) {
    params.push(`height=${height}`, 'fit=cover')
  }
  const paramStr = params.join(',')

  // Handle absolute CDN url
  if (url.startsWith('https://assets.auxodev.dk/assets/')) {
    const path = url.replace('https://assets.auxodev.dk/', '')
    return `${CDN_HOST}/cdn-cgi/image/${paramStr}/${path}`
  }

  // Handle /_assets/ relative path
  if (url.startsWith('/_assets/')) {
    const fileName = url.replace('/_assets/', '')
    return `${CDN_HOST}/cdn-cgi/image/${paramStr}/assets/${PROJECT_ID}/${fileName}`
  }

  // Bare filename of project asset
  if (/^[^/?#:]+\.(png|jpe?g|webp|gif|avif|svg)$/i.test(url)) {
    return `${CDN_HOST}/cdn-cgi/image/${paramStr}/assets/${PROJECT_ID}/${url}`
  }

  return url
}

export function getImageSrcSet(url, widths = [400, 800, 1200]) {
  if (!url || typeof url !== 'string') return undefined
  return widths
    .map((w) => `${getOptimizedImageUrl(url, { width: w })} ${w}w`)
    .join(', ')
}

export const imageUrl = getOptimizedImageUrl
export const srcSet = getImageSrcSet
export const assetPath = (u) => u
